import React from "react";
import { Col } from "antd";
import QuestionnaireGrid from "./QuestionBox";
import MaleAssessmentForm from "./MaleAssessmentForm";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./assesment.css";



export default function Assessment() {
  const cards = useSelector((state) => state.assessment);
  const { userAuth } = useSelector((state) => ({
    userAuth: state.authentication.userAuth,
  }));

  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  // Get user gender from authentication state or localStorage
  const getUserGender = () => {
    // Helper to normalize various key names
    const extractGender = (obj) => {
      if (!obj || typeof obj !== "object") return undefined;
      const possibleKeys = [
        "gender",
        "Gender",
        "sex",
        "Sex",
      ];
      for (const key of possibleKeys) {
        if (obj[key]) return String(obj[key]).toLowerCase();
      }
      return undefined;
    };

    // 1) Try localStorage userInfo (saved on login) - prefer this over Redux obj
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const fromLs = extractGender(userInfo);
    if (fromLs) return fromLs;

    // 2) Try nested userAuth.obj
    const fromAuthObj = extractGender(userAuth?.obj);
    if (fromAuthObj) return fromAuthObj;

    // 3) Try top-level userAuth
    const fromAuth = extractGender(userAuth);
    if (fromAuth) return fromAuth;

    // Default to female if no gender found (since API doesn't provide gender)
    return "female";
  };

  const userGender = getUserGender();
  if (process.env.NODE_ENV === 'development') {
    // Minimal debug to help verify the resolved gender without noisy logs in production
    // eslint-disable-next-line no-console
    console.log('Resolved userGender:', userGender);
  }

  return (
    <Col>
      {userGender === "male" ? (
        <MaleAssessmentForm />
      ) : (
        <>
          <div
            className="mt-4 assessment-container"
            style={{ color: "#111F4A", padding: "0 6%" }}
          >
            <p style={{ color: "#000", fontSize: 15, fontWeight: "bold" }}>
              Great to see you!
            </p>
            <p>
              Just a gentle nudge to complete your general intake form at your
              earliest convenience before your appointment.{" "}
            </p>
            <p>
              It helps us get to know you better and ensures a smoother
              experience.{" "}
            </p>
            <p>Thanks a bunch!</p>
          </div>
          <div>
            <QuestionnaireGrid
              cards={cards.map((card) => ({
                ...card
              }))}
              onCardClick={handleCardClick}
            />
          </div>
        </>
      )}
    </Col>
  );
}
